import React from 'react';
import useThemeColors from '../../hooks/useThemeColors';

const EffectBanner = ({ 
  title, 
  description, 
  growthValue, 
  growthLabel,
  icon: Icon,
  className = ""
}) => {
  const { isDark } = useThemeColors();
  
  return (
    <div className={`bg-gradient-to-r ${
      isDark 
        ? 'from-purple-700 to-pink-700' 
        : 'from-purple-600 to-pink-600'
    } text-white rounded-lg shadow-md border-0 ${className}`}>
      <div className="p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="space-y-2 flex-1">
            <h2 className="text-xl sm:text-2xl font-bold flex items-center gap-2">
              {Icon && <Icon className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" />}
              <span>{title}</span>
            </h2>
            <p className={`text-sm sm:text-base ${
              isDark ? 'text-purple-200' : 'text-purple-100'
            }`}>
              {description}
            </p>
          </div>
          <div className="text-left sm:text-right w-full sm:w-auto">
            <div className={`text-2xl sm:text-3xl font-bold ${
              isDark ? 'text-yellow-400' : 'text-yellow-300'
            }`}>
              +{growthValue}
            </div>
            <div className={`text-xs sm:text-sm ${
              isDark ? 'text-purple-300' : 'text-purple-200'
            }`}>
              {growthLabel}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EffectBanner; 